@if (isPromo()) {
    <div class="flex flex-row items-center w-full h-[480px] overflow-hidden max-[800px]:flex-col max-[800px]:h-auto max-[800px]:py-10">
        <div class="flex flex-col gap-4 basis-1/2 pl-[300px] pr-[100px] max-[1200px]:pl-[100px] max-[800px]:basis-auto max-[800px]:w-full max-[800px]:items-center max-[800px]:px-[60px]">
            <p-skeleton width="140px" height="18px" borderRadius="6px" />
            <p-skeleton width="70%" height="44px" borderRadius="8px" />
            <p-skeleton width="90%" height="16px" borderRadius="6px" />
            <p-skeleton width="80%" height="16px" borderRadius="6px" />
            <p-skeleton width="150px" height="46px" borderRadius="8px" styleClass="mt-2" />
        </div>
        <div class="flex justify-end basis-1/2 pr-[300px] max-[1200px]:pr-[100px] max-[800px]:basis-auto max-[800px]:w-full max-[800px]:justify-center max-[800px]:pr-0 max-[800px]:pt-8">
            <p-skeleton width="447px" height="300px" borderRadius="18px" styleClass="max-w-full" />
        </div>
    </div>
} @else {
    @if (showTitle()) {
        <p-skeleton width="220px" height="28px" borderRadius="6px" styleClass="ml-[35px] mb-5" />
    }
    <div class="flex pl-[35px] py-3 overflow-hidden">
        @for (i of cards(); track i) {
            @if (poster().circle) {
                <div class="shrink-0 mr-5 flex flex-col items-center gap-3.5">
                    <p-skeleton shape="circle" [size]="poster().width" />
                    <p-skeleton width="60%" height="16px" borderRadius="6px" />
                </div>
            } @else {
                <p-skeleton styleClass="shrink-0 mr-5" [width]="poster().width" [height]="poster().height" borderRadius="8px" />
            }
        }
    </div>
}
